<!-- Created by henian.xu on 2018/7/20. -->

<template>
    <page :back="queryFormModel.storeId">
        <!-- 表单区 -->
        <template slot="secondHeader">
            <el-form
                ref="queryForm"
                class="second-header npa-b"
                size="small"
                :inline="true"
                :model="queryFormModel"
            >
                <el-form-item
                    prop="storeId"
                    :label="$t('pageKey620', '门店')"
                    v-if="!queryFormModel.shopStoreId"
                >
                    <RemoteSelect
                        filterable
                        clearable
                        remote="/sp/shopStore/select"
                        :placeholder="$t('pageKey101', '请选择')"
                        :props="{id:'id',name:'storeName'}"
                        v-model="queryFormModel.storeId"
                        disabled-cache
                    />
                </el-form-item>
                <el-form-item
                    prop="userName"
                    :label="$t('pageKey63', '用户名')"
                    v-if="!queryFormModel.buyerId"
                >
                    <el-input
                        v-model="queryFormModel.userName"
                        :placeholder="$t('pageKey64', '请输入用户名')"
                    />
                </el-form-item>
                <el-form-item
                    prop="mobile"
                    :label="$t('pageKey121', '电话')"
                    v-if="!queryFormModel.buyerId"
                >
                    <el-input
                        v-model="queryFormModel.mobile"
                        :placeholder="$t('pageKey129', '请输入电话')"
                    />
                </el-form-item>
                <el-form-item>
                    <el-button
                        type="primary"
                        @click="onQuery()"
                    >
                        查询
                    </el-button>
                    <el-button
                        type="success"
                        @click="onReset"
                    >
                        重置
                    </el-button>
                </el-form-item>
            </el-form>
        </template>

        <!-- 内容 -->
        <div
            class="body"
            slot="body"
            v-loading="querying"
        >
            <!-- 操作 -->
            <div
                class="ma-b"
            >
                <el-button-group>
                    <el-button
                        type="success"
                        icon="el-icon-plus"
                        size="small"
                        @click="onAdd"
                    >
                        新增
                    </el-button>
                    <el-button
                        type="danger"
                        icon="el-icon-delete"
                        size="small"
                        @click="onDelete"
                        :disabled="!currentTableSelect.length"
                    >
                        删除
                    </el-button>
                </el-button-group>
            </div>

            <!-- 表格 -->
            <el-table
                stripe
                border
                size="small"
                :data="tableData"
                style="width: 100%"
                @selection-change="onTableSelectionChange"
            >
                <el-table-column
                    type="selection"
                    width="36"
                />
                <el-table-column
                    prop="storeName"
                    label="门店名称"
                    min-width="100"
                    v-if="!queryFormModel.shopStoreId"
                />
                <el-table-column
                    prop="userName"
                    label="用户名"
                    min-width="100"
                    v-if="!queryFormModel.buyerId"
                />
                <el-table-column
                    prop="mobile"
                    label="电话"
                    min-width="100"
                    v-if="!queryFormModel.buyerId"
                />
                <el-table-column
                    prop="levelName"
                    label="门店会员等级"
                    min-width="100"
                />
                <el-table-column
                    label="加入时间"
                    width="135"
                >
                    <template slot-scope="scope">
                        {{ scope.row.joinTime | moment('YYYY-MM-DD HH:mm:ss') }}
                    </template>
                </el-table-column>
                <el-table-column
                    fixed="right"
                    label="操作"
                    width="90"
                >
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="small"
                            @click="onTableEdit(scope.row)"
                        >
                            编辑
                        </el-button>
                        <el-button
                            type="text"
                            size="small"
                            @click="onTableDelete(scope.row.id)"
                        >
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="ma-t ta-r">
                <pagination
                    v-model="pagination"
                    @input="onQuery"
                />
            </div>
        </div>

        <!-- 弹框 -->
        <!-- 新增/编辑 -->
        <el-dialog
            :title="addDialog.formModel.id ? '编辑' : '新增'"
            center
            width="600px"
            :visible.sync="addDialog.isVisible"
            @closed="onAddDialogCancel"
        >
            <el-form
                ref="addForm"
                size="small"
                :model="addDialog.formModel"
                :rules="addDialog.formRules"
            >
                <el-form-item
                    prop="storeId"
                    label="门店会员"
                    label-width="6em"
                    v-if="!addDialog.formModel.id && !this.queryFormModel.shopStoreId"
                >
                    <RemoteSelect
                        remote="/sp/shopStore/selectByPage"
                        placeholder="请输入"
                        :props="{id:'id',name:'storeName'}"
                        :remote-params="{isAllowStoreBuyer:true}"
                        v-model="addDialog.formModel.storeId"
                        @change="changeBuyerStore"
                    />
                </el-form-item>
                <el-form-item
                    prop="buyerId"
                    label="会员"
                    label-width="6em"
                    v-if="!addDialog.formModel.id && this.queryFormModel.shopStoreId"
                >
                    <RemoteSelect
                        filterable
                        remote="/mb/buyer/selectByPage"
                        placeholder="请输入"
                        :props="{id:'id',name:'selectName'}"
                        v-model="addDialog.formModel.buyerId"
                    />
                </el-form-item>
                <el-form-item
                    prop="storeBuyerLevelId"
                    label="会员等级"
                    label-width="6em"
                    v-if="addDialog.formModel.storeId"
                >
                    <RemoteSelect
                        remote="/sp/shopStoreBuyerLevel/select"
                        placeholder="请输入"
                        :props="{id:'id',name:'levelName'}"
                        :remote-params="{storeId:this.addDialog.formModel.storeId}"
                        v-model="addDialog.formModel.storeBuyerLevelId"
                    />
                </el-form-item>
                <el-form-item
                    label-width="6em"
                    v-for="item in addDialog.buyerRegisterInfo"
                    :key="item.label"
                    :label="item.label"
                    v-if="addDialog.formModel.storeId"
                >
                    <el-input
                        v-model="item.value"
                        auto-complete="off"
                    />
                </el-form-item>
            </el-form>
            <div
                slot="footer"
                class="dialog-footer"
            >
                <el-button
                    type="primary"
                    size="small"
                    @click="onAddDialogConfirm"
                >
                    确 定
                </el-button>
                <el-button
                    size="small"
                    @click="onAddDialogCancel"
                >
                    取 消
                </el-button>
            </div>
        </el-dialog>
    </page>
</template>

<script>
import pagesMixin from '@/mixin/layout/pageMixin';
import { queryFormList } from 'vmf/src/mixins';

export default {
    name: 'Variable',
    mixins: [pagesMixin, queryFormList],
    data() {
        return {
            queryFormModel: {
                shopStoreId: '',
                buyerId: '',
                storeId: '',
                userName: '',
                mobile: '',
            },
            // 新增/编辑
            addDialog: {
                // 对话框显示
                isVisible: false,
                formModel: {
                    id: '',
                    buyerId: '',
                    storeId: '',
                    storeBuyerLevelId: '',
                },
                // 表单校验规则
                formRules: {
                    storeId: {
                        required: true,
                        message: this.$t('pageKey101', '请选择'),
                    },
                    storeBuyerLevelId: {
                        required: true,
                        message: this.$t('pageKey509', '请选择会员等级'),
                    },
                },
                buyerRegisterInfo: [],
            },
            // 表格数据
            tableData: [],
            // 表格当前选中行
            currentTableSelect: [],
        };
    },
    methods: {
        /* -- 方法 -- */
        // 请求列表数据
        getListData(queryData) {
            return this.$api.Mb.BuyerStore.data(queryData).then(json => {
                const res = json.data;
                this.tableData = res.data;
                this.pagination = res.pagination;
                return Promise.resolve(json);
            });
        },
        /* -- 事件 -- */
        onAdd() {
            this.addDialog.isVisible = true;
            this.$nextTick(() => {
                const { addForm } = this.$refs;
                addForm.resetFields();
                const { formModel } = this.addDialog;
                formModel.id = '';
                formModel.buyerId = this.queryFormModel.buyerId;
                formModel.storeId = this.queryFormModel.shopStoreId;
                this.addDialog.buyerRegisterInfo = [];
                if (formModel.storeId) {
                    this.changeBuyerStore();
                }
            });
        },
        onTableSelectionChange(val) {
            this.currentTableSelect = val;
        },
        onTableEdit(row) {
            const { formModel } = this.addDialog;
            this.$api.Mb.BuyerStore.getDetail({ id: row.id }).then(json => {
                const res = json.data.data;
                this.$utils.formModelMerge(formModel, res.buyerStore);
                this.addDialog.buyerRegisterInfo = res.buyerRegisterInfo || [];
            });
            this.addDialog.isVisible = true;
        },
        onTableDelete(ids) {
            this.$confirm('是否确定要删除！', '温馨提示', {
                type: 'warning',
            }).then(() => {
                this.$api.Mb.BuyerStore.delete({ ids }).then(json => {
                    const res = json.data;
                    this.$message({
                        message: res.msg,
                        type: 'success',
                    });
                    this.onQuery(this.pagination);
                });
            });
        },
        onDelete() {
            const ids = this.currentTableSelect.reduce((prev, next) => {
                prev.push(next.id);
                return prev;
            }, []);
            this.onTableDelete(ids.join(','));
        },
        onAddDialogConfirm() {
            const { addForm } = this.$refs;
            addForm.validate().then(() => {
                this.$api.Mb.BuyerStore.save({
                    ...this.addDialog.formModel,
                    buyerRegisterInfo: JSON.stringify(this.addDialog.buyerRegisterInfo),
                }).then(json => {
                    const res = json.data;
                    this.$message({
                        message: res.msg,
                        type: 'success',
                    });
                    this.onQuery(this.pagination);
                    this.addDialog.isVisible = false;
                });
            });
        },
        onAddDialogCancel() {
            const { addForm } = this.$refs;
            addForm.resetFields();
            const { formModel } = this.addDialog;
            formModel.id = '';
            this.addDialog.isVisible = false;
        },
        changeBuyerStore() {
            this.$api.Sp.ShopStore.getDetail({ id: this.addDialog.formModel.storeId, type: 1 }).then(json => {
                const res = json.data.data;
                this.addDialog.buyerRegisterInfo = JSON.parse(res.shopStore.otherConfig.buyerRegisterInfo);
            });
        },
    },
    created() {
        this.queryFormModel.buyerId = this.$route.params.buyerId;
        this.queryFormModel.shopStoreId = this.$route.params.shopStoreId;
    },
};
</script>

<style lang="scss">
</style>
